import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useHistory, useParams } from 'react-router-dom';
import AddClubHeader from "../../components/Headers/AddClubHeader.js";
import helper from '../../services/helper.service';
import customerApi from '../../services/customer.service';
import session from '../../services/session.service';

function AddMember() {
  const history = useHistory();
  const { memberId } = useParams(); // This will capture the memberId from the URL
  const [clubId, setClubId] = useState(session.get('clubInfo').clubId);
  
  // Form Fields
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  // State for managing form submission
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (memberId) {
      // If memberId is present, fetch member data for editing
      customerApi.getMemberById({member_id: memberId}).then(response => {
        if (response.status === 200) {
          const member = response.data;
          setFirstName(member.first_name);
          setLastName(member.last_name);
          setPhone(member.phone);
          setEmail(member.email);
          setIsEdit(true);
        } else {
          helper.showToast("Error", "Member not found", 3);
        }
      });
    }
  }, [memberId]);

  const submitMember = async () => {
    const memberData = {
      first_name: firstName,
      last_name: lastName,
      phone: phone,
      email: email,
      club_id: clubId
    };

    try {
      if (isEdit) {
        // Edit Member
        const response = await customerApi.updateMember({ member_id: memberId, ...memberData});
        if (response.status === 200) {
          helper.showToast('Success', 'Member updated successfully.', 1);
          history.push('/customer/members');  // Redirect to member list after success
        } else {
          helper.showToast('Error', 'Failed to update member.', 3);
        }
      } else {
        // Create New Member
        const response = await customerApi.addMember(memberData);
        if (response.status === 200) {
          helper.showToast('Success', 'Member added successfully.', 1);
          history.push('/customer/members');  // Redirect to member list after success
        } else {
          helper.showToast('Error', 'Failed to add member.', 3);
        }
      }
    } catch (error) {
      console.error("Error saving member: ", error);
      helper.showToast('Error', 'Invalid member details', 3);
    }
  };

  return (
    <>
      <AddClubHeader />
      <Container className="mt--9" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">{isEdit ? 'Edit Member' : 'Add Member'}</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">Member Information</h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label">First Name</label>
                          <Input
                            type="text"
                            value={firstName}
                            placeholder="John"
                            onChange={(e) => setFirstName(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label">Last Name</label>
                          <Input
                            type="text"
                            value={lastName}
                            placeholder="Doe"
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label">Phone</label>
                          <Input
                            type="text"
                            value={phone}
                            placeholder="(123) 456-7890"
                            onChange={(e) => setPhone(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label">Email</label>
                          <Input
                            type="email"
                            value={email}
                            placeholder="john@example.com"
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row dir='rtl' style={{marginRight: 10}}>
                      <Button color="primary" onClick={submitMember} size="sm">
                        {isEdit ? 'Save Changes' : 'Add Member'}
                      </Button>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AddMember;
